import app from 'flarum/forum/app';
import Search from 'flarum/forum/components/Search';
import SearchManager from 'flarum/common/SearchManager';
import { bootAiSparkle } from './ai';
import { bootAiModal } from './ai-modal';
import decorateResults from './decorateResults';
export { default as extend } from './extend';
app.initializers.add('glowingblue-search', () => {
  decorateResults();

  // The settings arrive on `app.forum`, which is only hydrated after
  // initializers run.
  app.beforeMount(() => {
    // MySQL fulltext floors at 3 characters; on an all-Elasticsearch install
    // admins can lower this. The forum-only Search component keeps its own copy.
    const min = Number(app.forum.attribute('glowingblueSearchMinChars'));
    if (Number.isInteger(min) && min > 0) {
      SearchManager.MIN_SEARCH_LEN = min;
      Search.MIN_SEARCH_LEN = min;
    }
    bootAiSparkle();
    bootAiModal();
  });
});